import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../AnimationContents';
import { GameModel } from '../../Models/GameModel';
import { GameLogic } from '../../Logic/GameLogic';
import { SoundModel } from '../../Models/SoundModel';
import add = PIXI.GroupD8.add;

export enum LeaderboardScreenItemType {
    coins,
    score
}

export interface ILeaderboardScreenItemControllerOptions {
    highlight: boolean;
    isPlayer: boolean;
    index: number;
    name: string;
    address: string;
    value: number;
}

export class LeaderboardScreenItemController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: ILeaderboardScreenItemControllerOptions,
        @Inject private _gameLogic: GameLogic,
        @Inject private _modelEvents: ModelEvents,
        @Inject private soundLevels: SoundModel,
    ) {
        super('LeaderboardScreenItemController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.LEADERBOARD_SCREEN_JSON,
            libraryName: 'leaderboard_players_place',
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this._options.isPlayer ? 'money_3' : (this._options.highlight ? 'money_1' : 'money_2'));

        let initialAddress = this._options.address;
        let address = initialAddress.slice(0, 4) + '...' + initialAddress.slice(initialAddress.length - 4, initialAddress.length);

        this.setTextByQuery('txt_name', this._options.name);
        this.setTextByQuery('txt_address', address);
        this.setTextByQuery('txt_place', this._options.index.toString());

        this.setTextVerticalAlignByQuery('txt_address', "middle");
        this.setTextVerticalAlignByQuery('txt_place', "middle");
        this.setTextVerticalAlignByQuery('txt_coins_value', "middle");
        // this.setTextVerticalAlignByQuery('inches', "middle");
        
        this.setTextByQuery('txt_coins_value', this._options.value.toString());
    }

    protected onResize(width: number, height: number, scale: number): void {
    }

    protected onUpdate(frameRate: number): void {
    }

    public getOptions(): ILeaderboardScreenItemControllerOptions {
        return this._options;
    }
}
